import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

type Medium = "tv" | "radio";

@Model()
class BroadcastRecorder extends ApplicationRecord {
  static jsonapiType = "broadcast_recorders";

  @Attr({ persist: false }) createdAt: string;

  @Attr() host: string;

  @Attr() medium: Medium;
}

export default BroadcastRecorder;
